import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "intro" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-inline d-sm-block d-xl-inline",
  for: "statistics"
}, "Show me ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select one", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "mean" }, "the Mean", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "median" }, "the Median", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "singleyear" }, "a Single Year", -1)
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "d-inline d-sm-block d-md-inline",
  for: "years"
}, " of the cloud cover for ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select one", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: ""
}, "Select one", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("hr", { style: {"width":"100%","margin-block":"1rem"} }, null, -1)
const _hoisted_14 = { class: "attention" }
const _hoisted_15 = {
  id: "awv-cloud-cover-display",
  class: ""
}
const _hoisted_16 = { class: "attention" }
const _hoisted_17 = {
  key: 0,
  style: {"color":"#ff0000"}
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  style: {"font-size":".91em"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { style: {"color":"#ccc"} }, "For all years:", -1)
const _hoisted_23 = { class: "map-colorbar" }
const _hoisted_24 = { class: "d-flex align-center justify-space-between" }
const _hoisted_25 = {
  class: "align-self-start text-right",
  id: "awv-map-description"
}
const _hoisted_26 = {
  key: 0,
  style: {"display":"inline-block","width":"100px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_define_term = _resolveComponent("define-term")!
  const _component_cloud_data_explainer = _resolveComponent("cloud-data-explainer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_cloud_cover_line = _resolveComponent("cloud-cover-line")!
  const _component_location_selector = _resolveComponent("location-selector")!
  const _component_color_bar = _resolveComponent("color-bar")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_line_chart = _resolveComponent("line-chart")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.showValue,
    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showValue) = $event)),
    "close-on-back": "",
    fullscreen: _ctx.$vuetify.display.width < 450 || _ctx.fullscreen
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { id: "advanced-weather-view" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "overflow-auto" }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, [
                _createTextVNode("Just how cloudy is it in " + _toDisplayString(_ctx.locationName) + " in April? ", 1),
                _createVNode(_component_define_term, {
                  "no-click": "",
                  width: "25ch",
                  showFor: _ctx.showFor ? 5 : 0
                }, {
                  definition: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, [
                      _createTextVNode(" Click"),
                      _createVNode(_component_v_icon, {
                        class: "pa-0",
                        size: "1.2em"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-help-circle")
                        ]),
                        _: 1
                      }),
                      _createTextVNode("for more details about the cloud cover data, statistical terms, and the El Niño & La Niña weather patterns. ")
                    ])
                  ]),
                  term: _withCtx(({props}) => [
                    _createVNode(_component_v_btn, _mergeProps(props, {
                      style: {"font-size":"1em"},
                      elevation: "1",
                      icon: "mdi-help-circle",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.explainerOpen = true)),
                      tabindex: "0"
                    }), null, 16)
                  ]),
                  _: 1
                }, 8, ["showFor"]),
                _createVNode(_component_cloud_data_explainer, {
                  modelValue: _ctx.explainerOpen,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.explainerOpen) = $event)),
                  fullscreen: _ctx.$vuetify.display.width < 450 || _ctx.fullscreen
                }, null, 8, ["modelValue", "fullscreen"])
              ]),
              _createVNode(_component_v_row, { class: "flex-row-reverse" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "5",
                    order: 2,
                    "order-lg": 2
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { id: "query-constructor" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            class: "sentence-query mb-2",
                            col: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2,
                              _withDirectives(_createElementVNode("select", {
                                class: "select-box",
                                name: "statistics",
                                id: "select-statistics",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedStat) = $event))
                              }, _hoisted_7, 512), [
                                [_vModelSelect, _ctx.selectedStat]
                              ]),
                              _hoisted_8,
                              (_ctx.selectedStat !== 'singleyear')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    class: "select-box",
                                    name: "years",
                                    id: "select-years",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.dataSubset) = $event))
                                  }, [
                                    _hoisted_9,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapSubsets, ([key, value]) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: key,
                                        value: key
                                      }, _toDisplayString(value), 9, _hoisted_10))
                                    }), 128))
                                  ], 512)), [
                                    [_vModelSelect, _ctx.dataSubset]
                                  ])
                                : _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 1,
                                    class: "select-box",
                                    name: "years",
                                    id: "select-years",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedYear) = $event))
                                  }, [
                                    _hoisted_11,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableYears, (year) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: year,
                                        value: year
                                      }, _toDisplayString(year), 9, _hoisted_12))
                                    }), 128))
                                  ], 512)), [
                                    [_vModelSelect, _ctx.selectedYear]
                                  ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_row, {
                        class: "mb-2",
                        id: "modis-radio-group"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_btn, {
                            class: "elevation-5 my-2 mb-4 mr-2",
                            size: "small",
                            disabled: !(_ctx.needToUpdate || !_ctx.showCloudCover),
                            color: "#eac402",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateData()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.displayData ? (_ctx.needToUpdate ? 'Update Map' : _ctx.showCloudCover ? 'Shown on Map' : 'Show on Map') : 'Show on Map'), 1)
                            ]),
                            _: 1
                          }, 8, ["disabled"]),
                          _createVNode(_component_v_radio_group, {
                            class: "modis-radio",
                            modelValue: _ctx.modisDataSet,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modisDataSet) = $event)),
                            density: "compact",
                            "persistent-hint": "",
                            inline: "",
                            hint: "MODIS Aqua Data Set"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modisTimes, ([key, value]) => {
                                return (_openBlock(), _createBlock(_component_v_radio, {
                                  key: key,
                                  label: value,
                                  value: key,
                                  disabled: false,
                                  color: "#eac402",
                                  density: "compact",
                                  hint: "MODIS Aqua Data Set"
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (!_ctx.displayCharts && _ctx.displayData)
                        ? (_openBlock(), _createBlock(_component_v_row, {
                            key: 0,
                            id: "awv-chart-placeholder"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13,
                              _createElementVNode("h4", null, [
                                _createTextVNode("Show cloud cover statistics for currently selected location: "),
                                _createElementVNode("strong", _hoisted_14, _toDisplayString(_ctx.locationName), 1)
                              ]),
                              _createVNode(_component_v_btn, {
                                density: "compact",
                                color: "#eac402",
                                "append-icon": "mdi-chevron-triple-right",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.displayCharts = true))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Show details")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.displayCharts)
                        ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("h3", null, [
                                    _createTextVNode(" Cloud Cover for "),
                                    _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.locationName), 1),
                                    _createTextVNode(":")
                                  ]),
                                  (!_ctx.inBounds)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Location not in bounds"))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_cloud_cover_line, {
                                    value: _ctx.locationValue,
                                    label: _ctx.selectedStat === 'singleyear' ? `${_ctx.selectedYear}` : _ctx.statText.get(_ctx.selectedStat) ?? 'Cloud Cover',
                                    codes: _ctx.skyCoverCodes,
                                    ranges: _ctx.skyCoverCodeRanges,
                                    icons: _ctx.skyCoverIcons,
                                    variant: "bold"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.selectedStat === 'singleyear')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.selectedYear), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                            _createTextVNode(_toDisplayString(_ctx.mapSubsets.get(_ctx.dataSubset)) + " ", 1),
                                            _hoisted_20,
                                            _createTextVNode(" " + _toDisplayString(_ctx.statText.get(_ctx.selectedStat)), 1)
                                          ]))
                                    ]),
                                    _: 1
                                  }, 8, ["value", "label", "codes", "ranges", "icons"])
                                ]),
                                _hoisted_21,
                                _hoisted_22,
                                _createVNode(_component_cloud_cover_line, {
                                  value: _ctx.median(_ctx.cloudDataNearLocation),
                                  label: "Median",
                                  codes: _ctx.skyCoverCodes,
                                  ranges: _ctx.skyCoverCodeRanges,
                                  icons: _ctx.skyCoverIcons,
                                  style: {"color":"#ccc"}
                                }, null, 8, ["value", "codes", "ranges", "icons"]),
                                _createVNode(_component_cloud_cover_line, {
                                  value: _ctx.mean(_ctx.cloudDataNearLocation),
                                  label: "Mean",
                                  codes: _ctx.skyCoverCodes,
                                  ranges: _ctx.skyCoverCodeRanges,
                                  icons: _ctx.skyCoverIcons,
                                  style: {"color":"#ccc"}
                                }, null, 8, ["value", "codes", "ranges", "icons"])
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    class: _normalizeClass([
              _ctx.needToUpdate || !_ctx.displayData || _ctx.loadingNewMap ? 'show-after' : '',
              _ctx.needToUpdate ? 'need-to-update' : '', 
              !_ctx.displayData ? 'no-data-shown' : '',
              ]),
                    id: "awv-map",
                    cols: "12",
                    sm: "7",
                    order: 1,
                    "order-lg": 1
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_location_selector, {
                          "detect-location": _ctx.showOnMap,
                          modelValue: _ctx.location,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.location) = $event)),
                          label: "Location",
                          "map-options": _ctx.mapOptions,
                          "place-circle-options": _ctx.placeCircleOptions,
                          "selected-circle-options": _ctx.selectedCircleOptions,
                          "selected-cloud-cover": _ctx.displayedCloudData,
                          "rectangle-degrees": 0.5,
                          "show-cloud-cover": _ctx.displayData && _ctx.showCloudCover,
                          onDataclick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.selectedDataIndex = $event.index; _ctx.selectedDataCloudCover = $event.cloudCover}),
                          "cloud-cover-opacity-function": _ctx.transferFunction,
                          "geo-json-files": _ctx.eclipsePaths,
                          onFinishLoading: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadingNewMap = false))
                        }, null, 8, ["detect-location", "modelValue", "map-options", "place-circle-options", "selected-circle-options", "selected-cloud-cover", "show-cloud-cover", "cloud-cover-opacity-function", "geo-json-files"]),
                        _createVNode(_component_color_bar, {
                          name: "cloud-cover",
                          nsteps: 20,
                          label: " Cloud Cover",
                          cmap: (x) => [`hsla(0,0%,100%, 1)`, _ctx.transferFunction(x)]
                        }, null, 8, ["cmap"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.mapDescriptionText), 1),
                        (!_ctx.displayData)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26))
                          : _createCommentVNode("", true),
                        (_ctx.displayData)
                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                              key: 1,
                              modelValue: _ctx.showCloudCover,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showCloudCover) = $event)),
                              label: "Show Cloud Cover",
                              color: "#eac402",
                              density: "compact",
                              "hide-details": ""
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _: 1
              }),
              (_ctx.displayCharts)
                ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        class: "graph-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_bar_chart, {
                            id: "cloud-histogram",
                            class: "elevation-5",
                            labels: _ctx.skyCoverCodes.map((v) => v.includes('/') ? [v.split('/')[0] + '/', v.split('/')[1]]: v),
                            "data-label": _ctx.hideHistogramSubset ? 'All Years' : 'Other Years',
                            "histogram-data": _ctx.cloudDataHistogram.map((v, i) => _ctx.locationHistogram.length > 0 ? v - _ctx.locationHistogram[i] : v),
                            "border-width": _ctx.hideHistogramSubset ? [1] : [0],
                            colors: _ctx.hideHistogramSubset ? _ctx.colorMap : ['#aaa'],
                            options: {scales: {y: {beginAtZero: true, max:20}}},
                            "bar-annotations": false,
                            "bar-offset": 1,
                            barAnnotationLabel: (v) => (v * 100/20).toFixed(0) + '%',
                            stacked: "",
                            "show-legend": _ctx.dataSubset !== 'allYears',
                            title: `Cloud Conditions for ${_ctx.locationName} ${_ctx.allYears[0]} - ${_ctx.allYears[_ctx.allYears.length - 1]}`,
                            "other-datasets": _ctx.hideHistogramSubset ? [] : [
                {
                  label: _ctx.mapSubsets.get(_ctx.dataSubset),
                  data: _ctx.locationHistogram,
                  backgroundColor: _ctx.colorMap, //'#c51b8a',
                  borderColor: 'black', //'#c51b8a',
                  borderWidth: 1,
                }
              ]
                          }, null, 8, ["labels", "data-label", "histogram-data", "border-width", "colors", "barAnnotationLabel", "show-legend", "title", "other-datasets"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "12",
                        sm: "6",
                        class: "graph-col"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_line_chart, {
                            "show-legend": _ctx.subsetSelected,
                            class: "elevation-5",
                            title: `Percent Cloud Cover for ${_ctx.locationName}`,
                            "scatter-data": _ctx.cloudDataNearLocation,
                            "scatter-options": {radius: 4 },
                            "scatter-label": !_ctx.subsetSelected ? 'All Years' : 'Other Years',
                            "other-data": _ctx.subsetData,
                            "y-range": [-.1,1.1],
                            "x-range": [new Date(2002, 9, 8), new Date(2023, 11, 8)],
                            "y-axis-options": {
                ticks: {callback: (value, index) => {
                          if (value < 0 || value > 1) {return;}
                          return (value * 100).toFixed(0) + '%';
                          }}},
                            timeseries: "",
                            color: "#aaa",
                            "show-scatter": "",
                            annotations: [..._ctx.skyCoverCodeRanges.map(([_,[min,max]],i) => {
                return {
                  type: 'box',
                  yMin: min/100,
                  yMax: max/100,
                  backgroundColor: _ctx.colorMap[i],
                  drawTime: 'beforeDraw',
                  borderColor: _ctx.colorMap[i]
                }
              }),
              ..._ctx.skyCoverCodeRanges.map(([label,[min,max]],i) => {
                return {
                  type: 'line',
                  borderWidth: 0,
                  drawTime: 'beforeDatasetsDraw',
                  
                  label: {
                    display: true,
                    color: 'black',
                    backgroundColor: 'transparent',
                    content: _ctx.skyCoverCodes[i],
                  },
                  xMin: new Date(2023, 0, 8),
                  yMin: (min + max) / 200,
                  yMax: (min + max) / 200,
                  };
                })
              ]
                          }, null, 8, ["show-legend", "title", "scatter-data", "scatter-label", "other-data", "x-range", "y-axis-options", "annotations"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { style: {"border-top":"1px solid white","margin-top":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                size: _ctx.showOnMap ? 'large' : 'default',
                color: "#eac402",
                variant: "flat",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.close()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Close")
                ]),
                _: 1
              }, 8, ["size"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "fullscreen"]))
}